import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/atendz.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Meus recentes <strong className="purple">Trabalhos</strong>
        </h1>
        <p style={{ color: "white" }}>
          Aqui estão alguns dos meus projetos mais recentes.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Atendtz"
              description="Sistema de atendimento e gestão inteligente.
Integra WhatsApp, automações, agendamentos e relatórios em tempo real.
Organize conversas, otimize o suporte e atenda com eficiência — tudo em um só lugar."

              demoLink="https://atend.me.lbsystems.com.br/"
            />
          </Col>

         

          

          

         

         
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
